const DG_INTEL_URL = "https://imp.slypandainteractive.com/dg_scan_read.php";
const DG_INTEL_CACHE_KEY = "ss:dg-intel-cache";
const DG_INTEL_CACHE_TTL_MS = 5 * 60 * 1000;

const readDungeonIntelCache = (teamId) => {
  if (!teamId) return null;
  try {
    const raw = localStorage.getItem(`${DG_INTEL_CACHE_KEY}:${teamId}`);
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    if (!parsed?.timestamp || !parsed?.data) return null;
    if (Date.now() - parsed.timestamp > DG_INTEL_CACHE_TTL_MS) return null;
    return parsed;
  } catch (err) {
    return null;
  }
};

const writeDungeonIntelCache = (teamId, data, timestamp) => {
  if (!teamId) return;
  try {
    localStorage.setItem(
      `${DG_INTEL_CACHE_KEY}:${teamId}`,
      JSON.stringify({
        timestamp,
        data
      })
    );
  } catch (err) {

  }
};

const sortDungeonLevels = (levels) =>
levels.slice().sort((a, b) => {
  const aLabel = String(a.label || "");
  const bLabel = String(b.label || "");
  const aNum = parseInt(aLabel.split(".", 1)[0], 10);
  const bNum = parseInt(bLabel.split(".", 1)[0], 10);
  if (Number.isFinite(aNum) && Number.isFinite(bNum) && aNum !== bNum) {
    return bNum - aNum;
  }
  return aLabel.localeCompare(bLabel);
});

const buildDungeonIntelMap = (entries) => {
  const map = new Map();
  (entries || []).forEach((entry) => {
    const galaxy = String(entry?.dungeonGalaxyName || "").trim();
    const dgCode = String(entry?.dungeonId || "").trim();
    if (!galaxy || !dgCode) return;

    const bossMap = entry?.dungeonBosses || {};
    const levels = (entry?.dungeonLevels || []).map((level) => {
      const label = String(level?.dungeonLevelNumber || "").trim();
      if (!label) return null;
      const monster = String(level?.dungeonMonster || "").trim();
      const boss = bossMap[label] ? String(bossMap[label]).trim() : "";

      if (boss) {
        const guards = monster && monster !== boss ? [monster] : [];
        return { label, boss, guards };
      }

      return { label, monsterType: monster };
    });

    const normalized = sortDungeonLevels(levels.filter(Boolean));
    map.set(`${galaxy.toLowerCase()}:${dgCode}`, normalized);
  });
  return map;
};

export const getDungeonIntelMap = async (teamId, options = {}) => {
  const { force = false, signal } = options;
  if (!teamId) return new Map();

  if (!force) {
    const cached = readDungeonIntelCache(teamId);
    if (cached) {
      return buildDungeonIntelMap(cached.data);
    }
  }

  const res = await fetch(`${DG_INTEL_URL}?team_id=${encodeURIComponent(teamId)}`, { signal });
  if (!res.ok) {
    throw new Error(`Failed to load DG scans (${res.status})`);
  }
  const data = await res.json();
  const entries = Array.isArray(data) ? data : data.dungeons || [];
  const map = buildDungeonIntelMap(entries);
  const timestamp = Date.now();
  writeDungeonIntelCache(teamId, entries, timestamp);
  return map;
};